import { useCallback } from 'react';
import { selectFacilityTypes, useAppInitStore } from '../../stores';

export const useFacilityTypes = () => {
	const facilityTypes = useAppInitStore(selectFacilityTypes);

	const getFacilityById = useCallback(
		(id: number) => {
			const facility = facilityTypes.find((f) => f.id === id);

			return facility;
		},
		[facilityTypes]
	);

	return { facilityTypes, getFacilityById };
};
